import { createFileRoute, redirect } from '@tanstack/react-router';
import { EditProfilePage } from '../components/profile/EditProfilePage';

export const Route = createFileRoute('/profile/edit')({
  beforeLoad: ({ location }) => {
    if (!localStorage.getItem('access_token')) {
      throw redirect({ to: '/sign-in', search: { redirect: location.pathname } });
    }
  },
  component: EditProfilePage,
});
